<div class="payment-result-container">
  <div class="payment-result-card animate-fade-in">
    @if (hasPaymentIdent() && isProcessingPaymentResult()) {
      <div class="icon-container processing" aria-hidden="true">
        <span class="payment-spinner"></span>
      </div>

      <h1 class="payment-title">{{ 'i18n.domain.payment-successful.processing-title' | translate }}</h1>

      <p class="payment-message">
        {{ 'i18n.domain.payment-successful.processing-message' | translate }}
      </p>
    } @else if (hasPaymentProcessingError()) {
      <div class="icon-container error" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="payment-icon">
          <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
        </svg>
      </div>

      <h1 class="payment-title">{{ 'i18n.domain.payment-successful.error-title' | translate }}</h1>

      <p class="payment-message">
        {{ 'i18n.domain.payment-successful.error-message' | translate }}
      </p>
    } @else {
      <div class="icon-container success" aria-hidden="true">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="payment-icon">
          <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
        </svg>
      </div>

      <h1 class="payment-title">{{ 'i18n.domain.payment-successful.title' | translate }}</h1>

      <p class="payment-message">
        {{ 'i18n.domain.payment-successful.message' | translate }}
      </p>
    }
  </div>
</div>
